<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    persistent
    max-width="1000"
    v-if="isDataLoadedFromServer"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Edit Product</h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
        <!--begin::Body-->
        <form class="row">
          <div class="col-12 col-sm-6 col-md-4">
            <v-select
              v-model="formData.customer_id"
              label="Customer"
              item-text="text"
              item-value="index"
              :items="serverData.customers"
              clearable
              outlined
              dense
              required
              :error-messages="customer_idErrors"
              @input="$v.formData.customer_id.$touch()"
              @blur="$v.formData.customer_id.$touch()"
            ></v-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <v-select
              v-model="formData.brand_id"
              label="Brand"
              item-text="text"
              item-value="index"
              :items="serverData.brands"
              clearable
              outlined
              dense
              :error-messages="brand_idErrors"
              @input="$v.formData.brand_id.$touch()"
              @blur="$v.formData.brand_id.$touch()"
            ></v-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <v-select
              v-model="formData.category_id"
              label="Category"
              item-text="text"
              item-value="index"
              :items="serverData.categories"
              clearable
              outlined
              dense
              :error-messages="category_idErrors"
              @input="$v.formData.category_id.$touch()"
              @blur="$v.formData.category_id.$touch()"
            ></v-select>
          </div>
          <div class="col-12 col-sm-6">
            <v-text-field
              v-model="formData.name"
              label="Name"
              clearable
              outlined
              dense
              :error-messages="nameErrors"
              @input="$v.formData.name.$touch()"
              @blur="$v.formData.name.$touch()"
            ></v-text-field>
          </div>
          <div class="col-12 col-sm-6">
            <v-file-input
              v-model="formData.image"
              show-size
              counter
              multiple
              dense
              outlined
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Photo"
              clearable
            ></v-file-input>
          </div>
          <div class="col-12">
            <v-text-field
              v-model="formData.description"
              label="Description"
              clearable
              outlined
              dense
            ></v-text-field>
          </div>

          <div class="col-12">
            <sku-datatable
              :setSku="setSkus"
              :skus="formData.skus"
              :skuItem="serverData.skus"
              :clientId="userId"
              :customer="getCustomerData"
            ></sku-datatable>
          </div>
        </form>
        <!--end::Body-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetEditForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitEditForm"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import SkuDatatable from "@/own/components/fulfillment/products/skuContainer/SkuDatatable";

export default {
  name: "EditItem",
  mixins: [validationMixin],
  validations: {
    formData: {
      customer_id: { required },
      brand_id: { required },
      category_id: { required },
      name: { required },
    },
  },
  props: ["refresher", "pageLoader"],
  components: { SkuDatatable },
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      id: null,
      customer_id: null,
      brand_id: null,
      category_id: null,
      name: null,
      description: null,
      image: null,
      skus: [],
    },
  }),
  methods: {
    setSkus(item) {
      this.formData.skus = [...item];
    },
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    loadDataFromServer() {
      this.pageLoader(true);
      let data = { id: this.$store.getters.getItemForAction.id };
      ApiService.post("/fulfillment/fulfillment_products/edit", data)
        .then((response) => {
          this.serverData = response.data;
          this.formData = { ...this.serverData.product };
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    convertToFormData() {
      let data = new FormData();
      let copy = { ...this.formData };
      let skus = this.formData.skus.map((sku) => sku.sku_id);
      copy.skus = skus;
      Object.entries(copy).forEach((item) => {
        if (
          (item[1] && item[0] !== "image" && item[0] !== "photo") ||
          item[1] === 0
        ) {
          if (Array.isArray(item[1])) {
            item[1].forEach((it, index) => {
              if (typeof it === "object" && !Array.isArray(it) && it !== null) {
                Object.entries(it).forEach((el) => {
                  data.append(`${item[0]}[${index}][${el[0]}]`, el[1]);
                });
              } else {
                data.append(`${item[0]}[]`, it);
              }
            });
          } else {
            data.append(item[0], item[1]);
          }
        } else if (item[1] && (item[0] === "image" || item[0] === "photo")) {
          data.append(item[0], item[1][0]);
        }
      });
      return data;
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.formData.skus.length === 0) {
        Swal.fire({
          title: "Warning",
          html: `<div>At least one sku is required!</div>`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.pageLoader(true);
      let data = this.convertToFormData();
      ApiService.post("/fulfillment/fulfillment_products/update", data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: `Record data has been updated`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetEditForm() {
      this.$v.$reset();
      if (this.serverData) {
        let copy = { ...this.serverData.product };
        Object.entries(this.formData).forEach((localData) => {
          Object.entries(this.serverData.product).forEach((serverData) => {
            if (localData[0] == serverData[0]) {
              this.formData[localData[0]] = copy[serverData[0]];
              // console.log(serverData[0], copy[serverData[0]]);
            }
          });
        });
      } else {
        this.formData = {
          id: null,
          customer_id: null,
          brand_id: null,
          category_id: null,
          name: null,
          description: null,
          image: null,
          skus: [],
        };
      }
    },
    toggleModal() {
      if (this.dialog) {
        this.serverData = null;
        this.resetEditForm();
      } else this.loadDataFromServer();

      this.dialog = !this.dialog;
    },
  },
  computed: {
    userId: function () {
      return this.isClient ? false : this.formData.customer_id;
    },
    getCustomerData() {
      return this.formData.customer_id ? this.formData.customer_id : false;
    },
    isDataLoadedFromServer: function () {
      return !!this.serverData;
    },
    customer_idErrors() {
      return this.handleFormValidation("customer_id", this);
    },
    brand_idErrors() {
      return this.handleFormValidation("brand_id", this);
    },
    category_idErrors() {
      return this.handleFormValidation("category_id", this);
    },
    nameErrors() {
      return this.handleFormValidation("name", this);
    },
  },
};
</script>
